module.exports = __webpack_public_path__ + "static/media/circular-std-medium.ecac1a6f.svg";